import { render, staticRenderFns } from "./r-difficulty.vue?vue&type=template&id=ecc7d522"
import script from "./r-difficulty.vue?vue&type=script&lang=js"
export * from "./r-difficulty.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ecc7d522')) {
      api.createRecord('ecc7d522', component.options)
    } else {
      api.reload('ecc7d522', component.options)
    }
    module.hot.accept("./r-difficulty.vue?vue&type=template&id=ecc7d522", function () {
      api.rerender('ecc7d522', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/utils/r-difficulty.vue"
export default component.exports